/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect } from 'react';
import { Close, Message, Error, Warning, Check } from '@mui/icons-material';
import { Animated } from 'react-animated-css';
import style from './toast.module.scss';

export enum NotificationType {
    Success = 1,
    Warning,
    Error,
    Message,
}

/* eslint-disable-next-line */
export interface ToastProps {
    type: NotificationType;
    text: string;
    duration?: number;
}

export function Toast(props: ToastProps) {
    const [visible, setVisible] = useState<boolean>(true);
    const [display, setDisplay] = useState<boolean>(true);

    const hideToast = () => {
        setVisible(false);
        setTimeout(() => {
            setDisplay(false);
        }, 600);
    };

    useEffect(() => {
        const timeout = setTimeout(
            () => {
                hideToast();
            },
            props.duration ? props.duration : 4500
        );

        return function cleanup() {
            clearTimeout(timeout);
        };
    }, []);

    return (
        <>
            {display && (
                // @ts-ignore
                <Animated animationIn='bounceInLeft' animationOut='bounceOutRight' isVisible={visible}>
                    <div className={style.toast}>
                        <div className={style[`type${props.type.toString().toLowerCase()}`]}>
                            {props.type === NotificationType.Success && <Check />}
                            {props.type === NotificationType.Warning && <Warning />}
                            {props.type === NotificationType.Error && <Error />}
                            {props.type === NotificationType.Message && <Message />}
                        </div>
                        <div className={style.content}>
                            <div className={style.name}>
                                {props.type === NotificationType.Success && <span>SUCCESS</span>}
                                {props.type === NotificationType.Warning && <span>WARNING</span>}
                                {props.type === NotificationType.Error && <span>ERROR</span>}
                                {props.type === NotificationType.Message && <span>INFO</span>}
                            </div>
                            <div className={style.text}>{props.text}</div>
                        </div>
                        <div className={style.close} onClick={hideToast}>
                            <Close />
                        </div>
                    </div>
                </Animated>
            )}
        </>
    );
}

export default Toast;
